import type { RouteObject } from "react-router-dom";
import { lazy } from "react";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import KindergartenPage from "../pages/grades/kindergarten/page";
import Grade1Page from "../pages/grades/grade1/page";
import Grade2Page from "../pages/grades/grade2/page";
import Grade3Page from "../pages/grades/grade3/page";
import Grade4Page from "../pages/grades/grade4/page";
import Grade5Page from "../pages/grades/grade5/page";
import Grade6Page from "../pages/grades/grade6/page";
import Grade7Page from "../pages/grades/grade7/page";
import Grade8Page from "../pages/grades/grade8/page";
import Grade9Page from "../pages/grades/grade9/page";
import Grade10Page from "../pages/grades/grade10/page";
import Grade11Page from "../pages/grades/grade11/page";
import Algebra1Page from "../pages/grades/algebra1/page";
import GeometryPage from "../pages/grades/geometry/page";
import Algebra2Page from "../pages/grades/algebra2/page";
import PreCalcPage from "../pages/grades/precalc/page";
import APCalcABPage from "../pages/grades/ap-calc-ab/page";
import APCalcBCPage from "../pages/grades/ap-calc-bc/page";
import APStatsPage from "../pages/grades/ap-stats/page";
import FreeLessonsPage from "../pages/free-lessons/page";
import FreeAlgebra1Page from "../pages/free-lessons/algebra1/page";
import Algebra1FreeLessons from "../pages/free-lessons/algebra1/page";
import GeometryFreeLessons from "../pages/free-lessons/geometry/page";
import Algebra2FreeLessons from "../pages/free-lessons/algebra2/page";
import WorksheetsPage from "../pages/worksheets/page";
import ACTMathWorksheetsPage from "../pages/act-math-worksheets/page";
import ACTMathStudyPlanPage from "../pages/act-math-study-plan/page";
import ACTMathPage from "../pages/test-prep/act/math/page";
import ACTSciencePage from "../pages/test-prep/act/science/page";
import TestPrepPage from "../pages/test-prep/page";
import ACTScienceWorksheetsPage from "../pages/act-science-worksheets/page";
import ACTScienceStudyPlanPage from "../pages/act-science-study-plan/page";
import ACTEnglishWorksheetsPage from "../pages/act-english-worksheets/page";
import Grade9WorksheetsPage from "../pages/grade-9-worksheets/page";
import Grade9StudyPlanPage from "../pages/grade-9-study-plan/page";
import Grade11WorksheetsPage from "../pages/grade-11-worksheets/page";
import Grade11StudyPlanPage from "../pages/grade-11-study-plan/page";
import Grade11ProgressPage from "../pages/grade-11-progress/page";
import APCalcABStudyPlanPage from "../pages/ap-calc-ab-study-plan/page";
import APCalcBCStudyPlanPage from "../pages/ap-calc-bc-study-plan/page";
import APCalcABProgressPage from "../pages/ap-calc-ab-progress/page";
import APCalcBCProgressPage from "../pages/ap-calc-bc-progress/page";
import APStatsStudyPlanPage from "../pages/ap-stats-study-plan/page";
import APStatsProgressPage from "../pages/ap-stats-progress/page";

const ACTMathProgressPage = lazy(() => import("../pages/act-math-progress/page"));
const ACTScienceProgressPage = lazy(() => import("../pages/act-science-progress/page"));
const ACTEnglishPage = lazy(() => import("../pages/test-prep/act/english/page"));
const ACTEnglishWorksheets = lazy(() => import('../pages/act-english-worksheets/page'));
const ACTEnglishStudyPlan = lazy(() => import('../pages/act-english-study-plan/page'));
const ACTEnglishProgressPage = lazy(() => import('../pages/act-english-progress/page'));

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/grade/k", element: <KindergartenPage /> },
  { path: "/grade/1", element: <Grade1Page /> },
  { path: "/grade/2", element: <Grade2Page /> },
  { path: "/grade/3", element: <Grade3Page /> },
  { path: "/grade/4", element: <Grade4Page /> },
  { path: "/grade/5", element: <Grade5Page /> },
  { path: "/grade/6", element: <Grade6Page /> },
  { path: "/grade/7", element: <Grade7Page /> },
  { path: "/grade/8", element: <Grade8Page /> },
  { path: "/grade/9", element: <Grade9Page /> },
  { path: "/grade/10", element: <Grade10Page /> },
  { path: "/grade/11", element: <Grade11Page /> },
  { path: "/algebra1", element: <Algebra1Page /> },
  { path: "/algebra2", element: <Algebra2Page /> },
  { path: "/geometry", element: <GeometryPage /> },
  { path: "/precalc", element: <PreCalcPage /> },
  { path: "/ap-calc-ab", element: <APCalcABPage /> },
  { path: "/ap-calc-bc", element: <APCalcBCPage /> },
  { path: "/ap-statistics", element: <APStatsPage /> },
  { path: "/worksheets", element: <WorksheetsPage /> },
  { path: "/act-math-worksheets", element: <ACTMathWorksheetsPage /> },
  { path: "/act-math-study-plan", element: <ACTMathStudyPlanPage /> },
  { path: "/act-math-progress", element: <ACTMathProgressPage /> },
  { path: "/act-science-worksheets", element: <ACTScienceWorksheetsPage /> },
  { path: "/act-science-study-plan", element: <ACTScienceStudyPlanPage /> },
  { path: "/act-science-progress", element: <ACTScienceProgressPage /> },
  { path: "/act-english-worksheets", element: <ACTEnglishWorksheetsPage /> },
  { path: "/grade-9-worksheets", element: <Grade9WorksheetsPage /> },
  { path: "/grade-9-study-plan", element: <Grade9StudyPlanPage /> },
  { path: "/grade-11-worksheets", element: <Grade11WorksheetsPage /> },
  { path: "/grade-11-study-plan", element: <Grade11StudyPlanPage /> },
  { path: "/grade-11-progress", element: <Grade11ProgressPage /> },
  { path: "/ap-calc-ab-study-plan", element: <APCalcABStudyPlanPage /> },
  { path: "/ap-calc-bc-study-plan", element: <APCalcBCStudyPlanPage /> },
  { path: "/ap-calc-ab-progress", element: <APCalcABProgressPage /> },
  { path: "/ap-calc-bc-progress", element: <APCalcBCProgressPage /> },
  { path: "/ap-stats-study-plan", element: <APStatsStudyPlanPage /> },
  { path: "/ap-stats-progress", element: <APStatsProgressPage /> },
  { path: "/free-lessons", element: <FreeLessonsPage /> },
  { path: "/free-lessons/algebra1", element: <FreeAlgebra1Page /> },
  { path: "/free-lessons/algebra1", element: <Algebra1FreeLessons /> },
  { path: "/free-lessons/geometry", element: <GeometryFreeLessons /> },
  { path: "/free-lessons/algebra2", element: <Algebra2FreeLessons /> },
  { path: "/test-prep", element: <TestPrepPage /> },
  { path: "/test-prep/act/math", element: <ACTMathPage /> },
  { path: "/test-prep/act/science", element: <ACTSciencePage /> },
  { path: "/test-prep/act/english", element: <ACTEnglishPage /> },
  { path: '*', element: <NotFound /> },
  { path: '/act-english-worksheets', element: <ACTEnglishWorksheets /> },
  { path: '/act-english-study-plan', element: <ACTEnglishStudyPlan /> },
  { path: '/act-english-progress', element: <ACTEnglishProgressPage /> },
];

export default routes;